const DEFAULT_PALETTE = [
  "#FFFFFF",
  "#D5D4D4",
  "#ABCAFF",
  "#81B0FF",
  "#0261FF",
  "#0141AA",
  "#012055",
  "#000000"
];

export { DEFAULT_PALETTE };
//# sourceMappingURL=defaults.js.map
